module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__summary-card mb-3"
  }, [_c('div', {
    staticClass: "pay-in__summary-card-header px-3 py-2 fs-small darkest",
    class: {
      'd-flex align-items-center': _vm.isFlexHeader,
      'pay-in__summary-card-header--clickable': _vm.collapsible
    },
    on: {
      "click": _vm.onHeaderClick
    }
  }, [_c('div', {
    class: {
      'd-flex align-items-center': _vm.payment.reference,
      'flex-grow-1': _vm.isFlexHeader
    }
  }, [(_vm.payment.reference) ? [_c('reference-avatar', {
    staticClass: "mr-2",
    attrs: {
      "reference": _vm.payment.reference,
      "index": _vm.index
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.payment.reference))])] : [_vm._v("\n                Payment " + _vm._s(_vm.index + 1)), (_vm.payment.itemsLabel) ? [_vm._v(" — " + _vm._s(_vm.truncateLabel(_vm.payment.itemsLabel)))] : _vm._e()]], 2), _vm._v(" "), (_vm.collapsible || _vm.amount !== null) ? _c('div', {
    staticClass: "d-flex align-items-center flex-shrink-0 ml-2"
  }, [(_vm.amount !== null) ? _c('span', {
    staticClass: "darkest fs-small font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.amount)) + _vm._s(_vm.currency))]) : _vm._e(), _vm._v(" "), (_vm.collapsible) ? _c('i', {
    staticClass: "ico ml-2 dark fs-small",
    class: _vm.expanded ? 'ico-arrow-top' : 'ico-arrow-bottom'
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsible || _vm.expanded),
      expression: "!collapsible || expanded"
    }],
    staticClass: "pay-in__summary-card-body px-3"
  }, [(_vm.isPartial) ? _vm._l((_vm.payment.items), function(item, i) {
    return _c('div', {
      key: 'item-' + i,
      staticClass: "pay-in__summary-row"
    }, [_c('span', {
      staticClass: "darkest fs-small"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "darkest fs-small"
    }, [_vm._v(_vm._s(_vm.formatPrice(item.total)) + "€")])])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment.paymentMethods), function(method, mi) {
    return _c('div', {
      key: 'method-' + mi,
      staticClass: "pay-in__summary-row"
    }, [(!method.typeName) ? _c('span', {
      staticClass: "darkest fs-small"
    }, [_vm._v("Payment method")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "darkest fs-small"
    }, [_vm._v(_vm._s(method.typeName))]), _vm._v(" "), _c('span', {
      staticClass: "darkest fs-small"
    }, [_vm._v(_vm._s(_vm.formatPrice(method.amountReceived)) + "€")])])
  }), _vm._v(" "), (_vm.payment.change > 0) ? _c('div', {
    staticClass: "pay-in__summary-row"
  }, [_c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v("Change")]), _vm._v(" "), _c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.payment.change)) + "€")])]) : _vm._e(), _vm._v(" "), (_vm.isFromCreatePayin) ? _c('div', {
    staticClass: "pay-in__summary-row"
  }, [_c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v(_vm._s(_vm.invoiceStatusText))])]) : _vm._e(), _vm._v(" "), (_vm.showBillingRow) ? _c('div', {
    staticClass: "pay-in__summary-row"
  }, [_c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v(_vm._s(_vm.billingDetailsText))])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-73d82544", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d82544"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/PayInSummaryCard.vue
// module id = 1978
// module chunks = 0